import React, { FC } from 'react';
import cls from 'classnames';

import { IMerchant, INavItem } from 'src/prize/types/shoppe';

import Header from './molecules/Header';
import Links from './molecules/Links';

import styles from './index.module.sass';

interface NavigationProps {
  isActive: boolean;
  links?: INavItem;
  merchant: IMerchant;
  onClose: () => void;
}

const Navigation: FC<NavigationProps> = ({ isActive, links, merchant, onClose }) => (
  <div className={cls( styles.container, { [styles.active]: isActive })}>
    <Header isVisible={isActive} merchant={merchant} onClose={onClose} />

    <Links header={links} />
  </div>
);

export default Navigation;
